import fetch from "@/uilts/request";



export default {
    async getGoodsList(data){
         return await  fetch.post("/Shop/getGoodsList",data)
    },

    async reviewGoods(data){
        return await  fetch.post("/Shop/reviewGoods",data)
    }
}